<template>
  <v-card class="mt-2">
    <v-card-title>国内仕入先（通関業者）</v-card-title>
    <v-card-actions>
      <v-btn @click="innerAdd">行追加</v-btn>
      <v-btn @click="innerEdit">編集</v-btn>
      <v-btn @click="innerRemove">{{$t('app.buttons.remove')}}</v-btn>
    </v-card-actions>

    <v-data-table
      :headers="innerHeaders"
      :items="company.accs.Customs_Director"
      :rows-per-page-items="[10]"
      class="elevation-0"
      item-key="key"
      select-all
      v-model="selected"
    >
      <template slot="items" slot-scope="props">
        <td>
          <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
        </td>
        <td>{{ props.item.buName }}</td>
        <td>{{ props.item.partnerName }}</td>
        <td>{{ props.item.portName }}</td>
      </template>
    </v-data-table>

    <inner-dialog :companyId="company.id" @create="innerCreate" ref="inner"></inner-dialog>
    <inner-edit-dialog :companyId="company.id" :custom="selected[0]" ref="edit"></inner-edit-dialog>
  </v-card>
</template>
<script>
import InnerDialog from './InnerDialog'
import InnerEditDialog from './InnerEdit'
export default {
  components: { InnerDialog, InnerEditDialog },
  props: ['company'],
  data() {
    return {
      innerHeaders: [
        { text: '事業本部', value: 'buName' },
        { text: '海外取引先', value: 'partnerName' },
        { text: '陸揚港', value: 'portCode' }
      ],
      result: [],
      selected: [],
      innerResult: [],
      pagination: {
        rowsPerPage: 5,
        page: 1
      },
      innerPagination: {
        rowsPerPage: 5,
        page: 1
      },
      query: {},
      buUrl: `divisions/kv?type=BU&companyId=${this.company.id}`,
      departmentUrl: `divisions/kv?type=DEPARTMENT&companyId=${
        this.company.id
      }`,
      employeeUrl: `employees/kv?companyId=${this.company.id}`
    }
  },
  methods: {
    innerAdd() {
      this.$refs.inner.popup()
    },
    innerEdit() {
      this.$refs.edit.popup()
    },
    load() {},
    innerCreate(item) {
      var data = {}
      if (item.bu != null) {
        data = { ...data, buId: item.bu.value, buName: item.bu.text }
      }
      if (item.port != null) {
        data = {
          ...data,
          portCode: item.port.value,
          portName: item.port.text
        }
      }
      if (item.partner != null) {
        data = {
          ...data,
          partnerId: item.partner.value,
          partnerName: item.partner.text
        }
      }
      // if (item.customsDirectorId != null) {
      //   data = {
      //     ...data,
      //     customsDirectorId: item.customsDirectorId.value,
      //     customsDirectorName: item.customsDirectorId.text
      //   }
      // }
      this.company.accs.Customs_Director.push({
        ...data,
        key: new Date().getTime()
      })
    },
    innerRemove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          this.company.accs.Customs_Director = this.company.accs.Customs_Director.filter(
            d => this.selected.indexOf(d) === -1
          )
          this.$message('', '削除成功')
        }
      )
    }
  },
  mounted() {
    this.load()
  }
}
</script>
